import React, {useEffect, useState} from "react";
import {ButtonGroup, Grid} from "@material-ui/core";
import Loader from "../../components/loading";
import axios from "axios";
import {useDispatch,} from "react-redux";
import {confirmationHandler} from '../../store/actions'
import {
  BestSellerCarousel,
  CategoryCard,
  EffortStatictics,
  Footer, InvestmentOpportunityCarousel,
  MainHeading,
  MonthlyStateUserOrder,
  OfferCard,
  SellerCard,
  TopNavBar,
} from "../../components";
import SwipeableTextMobileStepper1 from "../../components/home/carousel/featureProductCarousel";
import SwipeableTextMobileStepper2 from "../../components/home/carousel/featureServicesCarousel";
import HttpService from "../../services/http.service";
import {withRouter} from "react-router-dom";
import {getUserDataFromLocalStorage} from "../../services/utils";
import {APP_DOMAIN_PREFIX} from "../../environment";
import heroFieldCrew from "../../assets/images/newHome/hero-field-crew.png";
import trustExchange from "../../assets/images/newHome/trust-exchange.png";
import "./style.scss";

function NewHomePage(props) {
  const [farmingproducts, setFarmingproducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [nonfarmingProducts, setNonFarmingproducts] = useState([]);
  const [bestSellerProducts, setBestSellerProducts] = useState([]);
  const [currentPromotions, setCurrentPromotions] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [homepageStats, setHomepageStats] = useState({});
  let loginUser = getUserDataFromLocalStorage()
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState([])
  const [sellerFilter, setSellerFilter] = useState("all");
  const dispatcher = useDispatch();

  useEffect(() => {
    axios.post(`${APP_DOMAIN_PREFIX}/api/featuredproducts/list`).then((res) => {
      if (res) {
        setTopProducts(res.data);
      }
    });
    if (loginUser && loginUser.ssoId)
      axios.get(`${APP_DOMAIN_PREFIX}/api/getMyVerificationStatus?ssoId=${loginUser.ssoId}`).then((res) => {
        if (res) {
          localStorage.setItem(
            "verification",
            JSON.stringify(res.data)
          );
        }
      });
    axios.get(`${APP_DOMAIN_PREFIX}/api/categories`).then((res) => {
      if (res) {
        setCategories(
          (res.data || []).map((category) => ({
            id: category.id,
            agriSectorDescription: category.name,
            sectorImage: category.image_url,
          }))
        );
      }
    });
    axios.get(`${APP_DOMAIN_PREFIX}/api/marketplace/getProductByCategory`).then((res) => {
      if (res) {
        localStorage.setItem(
          "farming",
          JSON.stringify(res.data.farmingproducts)
        );
        let data = res.data.farmingproducts;
        let serviceData = {...data[0]}
        serviceData.agriSectorDescription = 'Agri Services & Inputs'
        data.push(serviceData)

        setFarmingproducts(res.data.farmingproducts);
        setFarmingproducts(data);
        setNonFarmingproducts(res.data.nonfarmingproducts);
        setBestSellerProducts(res.data.bestSellerProducts);
        setCurrentPromotions(res.data.currentPromotions);
        setFeaturedProducts(res.data.featuredProducts);
        setLoading(false);

        localStorage.setItem(
          "nonfarming",
          JSON.stringify(res.data.nonfarmingproducts)
        );
      }
    });
    axios.get("https://geolocation-db.com/json/", {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      localStorage.setItem("ip", JSON.stringify(res.data));
      if (res.data && res.data.country_code)
        HttpService.setToken(res.data.country_code)
    }).catch(res => console.log(res));
    axios.post(`${APP_DOMAIN_PREFIX}/api/servcies/list/all`).then((res) => {
      if (res) {
        setAllServices(res.data);
      }
    });
    axios.post(`${APP_DOMAIN_PREFIX}/api/mysearches/findAll`).then(res => {
      if (res) {
        setSearch(res.data)
      }
    });
    axios.get(`${APP_DOMAIN_PREFIX}/api/homepage/stats`).then((res) => {
      if (res) {
        setHomepageStats(res.data);
      }
    });
  }, []);

  const onItemClick = (item) => {
    let pathName = item?.agriSectorDescription === 'Agri Services & Inputs' ? '/services' : '/result'
    props.history.push({
      pathname: pathName,
      state: {category: item.agriSectorDescription},
    });
  };
  const onSearchClick = (item, category) => {
    props.history.push({
      pathname: "/result",
      state: {search: item, category: category},
    });
  };
  const onSellerItemClick = (index, item) => {
    props.history.push({
      pathname: `/detail/${item?.harvestId}`,
      state: {product: item},
    });
  };
  return (
    <div className="new-home-page">
      <TopNavBar onClick={onSearchClick}/>

      {/*hero*/}
      <div
        className="nh-hero"
        style={{backgroundImage: `url(${heroFieldCrew})`}}
      >
        <div className="nh-hero-content">
          <div className="nh-hero-eyebrow">Traceable, Trusted, Local</div>
          <h1 className="nh-hero-title">From the field to your table, verified every step</h1>
          <p className="nh-hero-subtitle">
            Buy and sell farm produce, livestock and agri-services directly with growers across
            the country &mdash; every listing backed by real inspections and honest pricing.
          </p>
          <div className="nh-hero-actions">
            <button
              className="nh-btn-primary"
              onClick={() => document.getElementById("nh-categories")?.scrollIntoView({behavior: "smooth"})}
            >
              Browse Marketplace
            </button>
            <button
              className="nh-btn-ghost"
              onClick={() => props.history.push("/signup")}
            >
              Start Selling
            </button>
          </div>
        </div>
      </div>

      <Grid container alignItems="center" className="after-navbar-container">
        <Grid item lg={12} md={12} sm={12} xs={12} className="p-20 mt-20 nh-section nh-section-tint">
          <BestSellerCarousel topProducts={bestSellerProducts}/>
        </Grid>
        {/*category view*/}
        <Grid
          item
          id="nh-categories"
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="p-main nh-section nh-section-tint"
        >
          <Grid container direction="column" style={{}}>
            <MainHeading title={"categories"}/>
            <Grid container spacing={1} className="justify-content-between">
              {loading && <Loader/>}
              {(categories || []).map((item, index) => {
                return (
                  <CategoryCard
                    key={index}
                    data={item}
                    onClick={() => onItemClick(item)}
                  />
                );
              })}
            </Grid>
          </Grid>
        </Grid>
        {/*best sellers*/}
        <Grid
          container
          direction="column"
          className="p-main nh-section nh-section-white"
        >
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <MainHeading title={"best sellers"}/>
            </Grid>
            <Grid item>
              <ButtonGroup className="nh-tab-group">
                <button
                  className={`border-none p-10 text-bold ${sellerFilter === "all" ? "nh-tab-active" : "black-color"}`}
                  onClick={() => setSellerFilter("all")}
                >
                  Show all
                </button>
                <button
                  className={`border-none p-10 text-bold ${sellerFilter === "auction" ? "nh-tab-active" : "black-color"}`}
                  onClick={() => setSellerFilter("auction")}
                >
                  Auction
                </button>
                <button
                  className={`border-none p-10 text-bold ${sellerFilter === "buyNow" ? "nh-tab-active" : "black-color"}`}
                  onClick={() => setSellerFilter("buyNow")}
                >
                  Buy now
                </button>
              </ButtonGroup>
            </Grid>
          </Grid>

          <Grid direction="row" container>
            {loading && <Loader/>}
            {(bestSellerProducts || []).map((item, index) => {
              return (
                <SellerCard
                  key={index}
                  data={item}
                  lg={2}
                  onClick={(event) => onSellerItemClick(index, item)}
                />
              );
            })}
          </Grid>
        </Grid>
        {/*trust strip*/}
        <Grid item lg={12} md={12} sm={12} xs={12} className="p-main nh-section nh-section-tint">
          <div
            className="nh-trust-strip"
            style={{backgroundImage: `url(${trustExchange})`}}
          >
            <div className="nh-trust-content">
              <h3 className="nh-trust-title">Every trade, verified hand to hand</h3>
              <p className="nh-trust-copy">
                Quality checks, smart contracts and transparent negotiation mean what you see
                listed is exactly what arrives at your door.
              </p>
            </div>
          </div>
        </Grid>
        {/*investment opportunity */}
        <Grid
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className=" "
          style={{
            paddingTop: "2%",
            paddingBottom: "2%",
          }}
        >
          <InvestmentOpportunityCarousel
            data={search}
          />
        </Grid>
        {/*featured product*/}
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="p-20 nh-section nh-section-tint"
        >
          <SwipeableTextMobileStepper1
            data={featuredProducts}
            loading={loading}
            onSellerItemClick={onSellerItemClick}
          />
        </Grid>

        {/*featured services*/}
        <Grid
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="nh-section nh-section-tint"
        >
          <SwipeableTextMobileStepper2
            data={allServices}
            loading={loading}
          />
        </Grid>

        {/*special offers*/}
        <Grid
          container
          direction="column"
          className="p-main nh-section nh-section-white"
          style={{padding: 20}}
        >
          <MainHeading title="Special Offers"/>

          <Grid className="display-flex flex-wrap ">
            {loading && <Loader/>}
            {(currentPromotions || []).map((item, index) => {
              return <OfferCard key={index} data={item}/>;
            })}
          </Grid>
        </Grid>
        {/*services*/}
        <Grid
          item
          lg={12}
          md={12}
          className="p-main nh-section nh-section-tint"
        >
          <EffortStatictics/>
        </Grid>

        {/*monthly detail*/}
        <Grid
          container
          direction="column"
          className="p-main nh-section nh-section-white"
          style={{padding: 20}}
        >
          <MonthlyStateUserOrder stats={homepageStats}/>
        </Grid>
        <Grid item lg={12} md={12}>
          <Footer/>
        </Grid>
      </Grid>
    </div>
  );
}

export default withRouter(NewHomePage);
